import {
  Box,
  Text,
  Flex,
  Modal,
  Button,
  Divider,
  ModalBody,
  ModalFooter,
  ModalContent,
  ModalOverlay,
} from "@chakra-ui/react";
import moment from "moment";
import { useFormik } from "formik";

import DataBox from "components/databox";
import FormikTextArea from "components/formikTextArea";

const ViewModal = ({ isOpen, onClose, request }) => {
  const formik = useFormik({
    initialValues: {
      description: request?.description,
      kwc_action: request?.kwc_action,
    },
  });

  const kwc_actions = request?.kwc_actions;
  const kwc_action = kwc_actions[kwc_actions?.length - 1];
  const previous_responses = kwc_actions?.slice(0, -1).reverse();

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered={true}>
      <ModalOverlay />
      <ModalContent minH={"300px"} minW={"800px"} p={4} borderRadius={"16px"}>
        <ModalBody display={"flex"} flexDirection={"column"} gap={6}>
          <Text
            color={"#000000"}
            fontFamily="PlusJakartaSansSemiBold"
            fontSize={"24px"}
            lineHeight={"32px"}
            textTransform={"capitalize"}
          >
            View Request
          </Text>
          <Divider />
          <Box>
            <Text
              color={"#000000"}
              fontFamily="PlusJakartaSansSemiBold"
              fontSize={"16px"}
              lineHeight={"22px"}
              textTransform={"capitalize"}
              mb={2}
            >
              Request Details
            </Text>
            <Box border="1px solid #D9D9D9" borderRadius="6px" p={4}>
              <DataBox
                label={"Requested by"}
                data={
                  request?.requested_by?.first_name +
                  " " +
                  request?.requested_by?.surname
                }
                labelColor={"#000000"}
              />
              <Flex gap={4} my={"20px"}>
                <DataBox
                  label={"Date Raised"}
                  data={moment(request?.date_raised).format("DD/M/YYYY")}
                  labelColor={"#000000"}
                />
                <DataBox
                  label={"Requested Type"}
                  data={request?.request_type}
                  labelColor={"#000000"}
                />
              </Flex>
              <Flex gap={4} my={"20px"}>
                <DataBox
                  label={"Assigned To"}
                  data={request?.assigned_to?.name}
                  labelColor={"#000000"}
                  containerStyles={{
                    minHeight: "44px",
                  }}
                />
                <DataBox
                  label={"Status"}
                  data={request?.status}
                  labelColor={"#000000"}
                />
              </Flex>
              <Flex my={"20px"}>
                <FormikTextArea
                  formik={formik}
                  name={"description"}
                  label={"description"}
                  labelColor={"#000000"}
                  disabled
                  disabledStyle={{
                    color: "black",
                  }}
                />
              </Flex>
            </Box>
          </Box>
          <Flex direction={"column"}>
            <Text
              color={"#000000"}
              fontFamily="PlusJakartaSansSemiBold"
              fontSize={"16px"}
              lineHeight={"22px"}
              textTransform={"capitalize"}
            >
              KWC Action
            </Text>
            <DataBox
              label={""}
              data={moment(kwc_action?.date).format("DD/MM/YYYY")}
              color={"black"}
            />
          </Flex>
          {previous_responses?.length !== 0 && (
            <Box>
              <Text
                color={"#000000"}
                fontFamily="PlusJakartaSansSemiBold"
                fontSize={"16px"}
                lineHeight={"22px"}
                textTransform={"capitalize"}
                mb={2}
              >
                Previous Responses
              </Text>
              <Box
                border="1px solid #D9D9D9"
                borderRadius="6px"
                p={4}
                gap={3}
                display={"flex"}
                flexDirection={"column"}
              >
                {previous_responses?.map((item, index) => {
                  return (
                    <Box
                      key={index}
                      border="1px solid #D9D9D9"
                      borderRadius="4px"
                      p={4}
                    >
                      <Text
                        color={"#000000"}
                        fontFamily="PlusJakartaSansRegular"
                        fontSize={"16px"}
                        lineHeight={"20px"}
                      >
                        {item?.value}
                      </Text>
                      <Text
                        color={"#898989"}
                        fontFamily="PlusJakartaSansRegular"
                        fontSize={"12px"}
                        lineHeight={"20px"}
                      >
                        {moment(item?.date).format("DD/MM/YYYY")}
                      </Text>
                    </Box>
                  );
                })}
              </Box>
            </Box>
          )}
        </ModalBody>
        <ModalFooter>
          <Flex w={"100%"} justify={"end"} gap={4}>
            <Button
              bg={"transparent"}
              border={"1px solid #000000"}
              color="#000000"
              size="12px"
              borderRadius="12px"
              fontFamily="PlusJakartaSansMedium"
              w={"174px"}
              h={"40px"}
              textTransform={"uppercase"}
              onClick={onClose}
            >
              CLOSE
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ViewModal;
